import React from "react";
import './search.css';

const stopPropagation = (e) => e.stopPropagation();

// Main-screen line describing the active search and filters, with a clear button
// that sits right after the text.
export default function NowShowing({ parts, loading, onClear }) {
    return (
        <div className="now-showing" onClick={stopPropagation} onMouseDown={stopPropagation}>
            <span className="now-showing-text">{loading ? 'SEARCHING…' : parts.join(' · ')}</span>
            <button type="button" className="now-showing-clear" aria-label="Clear search and filters" onClick={onClear}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" aria-hidden="true">
                    <path d="M5 5l14 14M19 5L5 19" />
                </svg>
            </button>
        </div>
    );
}
